//
//
//
//

import SkillStats from '@/components/SkillsInventory/Charts/SkillStats.vue'
export default {
  components: {
    SkillStats,
  },
  props: {
    projectId: {
      type: Number,
      required: true,
    },
  },
  async fetch() {
    try {
      this.isLoading = true
      this.skillStats = await this.$repository.skill.getProjectSkillStats(
        this.projectId
      )
    } catch (error) {
      this.handleError(error, this.$t('skillsInventory.error.skillStats'))
    } finally {
      this.isLoading = false
    }
  },
  data: () => ({
    isLoading: true,
    skillStats: {
      totalsByAge: [],
      totalsByGender: [],
    },
  }),
}
